import { IonContent } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { CompanyDetailsFooter } from '@/components/CompanyDetailsFooter';
import { S3_BUCKET_URL } from '@/constants';
import { amplitudeModule } from '@/modules/amplitude';
import { OnboardingNavigation } from '@/pages/Onboarding/components/Navigation';
import {
  OptionItemSquare,
  OptionItemSquareList,
} from '@/pages/Onboarding/components/OptionItemSquare/OptionItemSquare';
import { useOnboarding } from '@/pages/Onboarding/context';
import {
  OwnAiTitle,
  OwnAiTitleHighlight,
} from '@/pages/Onboarding/Layouts/OwnAI/components/Title';
import { HAIR_COLOR_OPTIONS } from '@/pages/Onboarding/options/HairColor/HAIR_COLOR_OPTIONS';
import { OnbOptionType } from '@/pages/Onboarding/types';
import { nextStepTimeout } from '@/pages/Onboarding/utils/nextStepTimeout';
import { userService } from '@/services/user';
import { canLogEvents } from '@/utils/canLogEvents';

import { LayoutDataType } from '../../types';

import { ScreenHairColorStyles } from './HairColor.styles';

const getImageSrc = (id: string) =>
  `${S3_BUCKET_URL}/layout-own-ai/hair_color/${id}.png`;

export const ScreenHairColor: React.FC = () => {
  const { wizard } = useOnboarding();
  const form = useFormContext<LayoutDataType>();
  const hairColor = form.watch('hair_color');

  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'HairColor',
      });
    }
  }, []);

  const handleSelect = (
    option: OnbOptionType<LayoutDataType['hair_color']>,
  ) => {
    form.setValue('hair_color', option.id);
    userService.createOrUpdate({
      onboarding_data: {
        hair_color: option.title,
      },
    });
    nextStepTimeout(wizard.nextStep);
  };

  return (
    <ScreenHairColorStyles>
      <OnboardingNavigation />

      <OwnAiTitle className="local-title">
        Select her <OwnAiTitleHighlight>hair color</OwnAiTitleHighlight>
      </OwnAiTitle>

      <IonContent>
        <OptionItemSquareList>
          {HAIR_COLOR_OPTIONS.map((option) => (
            <OptionItemSquare
              key={option.id}
              isSelected={hairColor === option.id}
              onClick={() => handleSelect(option)}
              bgSrc={getImageSrc(option.id)}
              title={option.title}
              TEST_ID={`hair_color-${option.id}`}
            />
          ))}
        </OptionItemSquareList>
      </IonContent>

      <CompanyDetailsFooter extraPadding />
    </ScreenHairColorStyles>
  );
};
